"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.9791 17.4375C40.9219 17.2151 40.8151 17.0085 40.6666 16.8333L30.3541 4.47917C30.1719 4.28967 29.9519 4.14061 29.7083 4.04167C29.4215 3.79993 29.0623 3.66065 28.6875 3.64584H14.3125C12.7606 3.75275 11.3145 4.47076 10.2912 5.64241C9.26798 6.81405 8.75117 8.34369 8.85414 9.89584V40.125C8.75117 41.6772 9.26798 43.2068 10.2912 44.3784C11.3145 45.5501 12.7606 46.2681 14.3125 46.375H35.6875C37.2394 46.2681 38.6855 45.5501 39.7087 44.3784C40.732 43.2068 41.2488 41.6772 41.1458 40.125V18.125C41.1451 17.8859 41.088 17.6504 40.9791 17.4375ZM36.375 16.6667H33.6458C33.2368 16.6897 32.8275 16.6275 32.4437 16.484C32.06 16.3406 31.7103 16.119 31.4166 15.8333C30.9947 15.3471 30.6742 14.7816 30.4739 14.1698C30.2735 13.558 30.1974 12.9124 30.25 12.2708V9.22917L36.375 16.6667ZM38.0208 40.2292C38.0208 41.9167 36.9583 43.3333 35.6875 43.3333H14.3125C13.0416 43.3333 11.9791 41.9167 11.9791 40.2292V9.875C11.9791 8.1875 13.0416 6.77084 14.3125 6.77084H27.0833V12.1458C27.0251 13.2015 27.1795 14.2581 27.5374 15.253C27.8953 16.2479 28.4493 17.1608 29.1666 17.9375C29.7607 18.5105 30.4624 18.9602 31.2312 19.2605C32 19.5609 32.8206 19.706 33.6458 19.6875H38L38.0208 40.2292Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.8125 22.2708H16.25C16.0448 22.2708 15.8416 22.3113 15.652 22.3898C15.4625 22.4683 15.2902 22.5834 15.1451 22.7285C15 22.8736 14.8849 23.0458 14.8064 23.2354C14.7279 23.425 14.6875 23.6281 14.6875 23.8333C14.6875 24.0385 14.7279 24.2417 14.8064 24.4313C14.8849 24.6208 15 24.7931 15.1451 24.9382C15.2902 25.0833 15.4625 25.1984 15.652 25.2769C15.8416 25.3554 16.0448 25.3958 16.25 25.3958H31.8125C32.2269 25.3958 32.6243 25.2312 32.9173 24.9382C33.2104 24.6452 33.375 24.2477 33.375 23.8333C33.375 23.4189 33.2104 23.0215 32.9173 22.7285C32.6243 22.4355 32.2269 22.2708 31.8125 22.2708Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.9791 31.5833H16.25C15.8356 31.5833 15.4381 31.748 15.1451 32.041C14.8521 32.334 14.6875 32.7314 14.6875 33.1458C14.6875 33.5602 14.8521 33.9577 15.1451 34.2507C15.4381 34.5437 15.8356 34.7083 16.25 34.7083H25.9791C26.3935 34.7083 26.791 34.5437 27.084 34.2507C27.377 33.9577 27.5416 33.5602 27.5416 33.1458C27.5416 32.7314 27.377 32.334 27.084 32.041C26.791 31.748 26.3935 31.5833 25.9791 31.5833Z",
    fill: fill
  }));
};

exports["default"] = _default;